import { Box, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import Relacionamentos from "./Relacionamentos";
import DadosCadastrais from "./DadosCadastrais";

export default function FormIncluirAgrotoxico() {
    const { watch, setValue } = useFormContext();
//valores importantes
    const activeStep = watch("stepper");

    const [selected, setSelected] = useState<readonly string[]>([]);


    // Steps
    const steps: Array<ISteps> = [
        {
            label: "Dados Cadastrais",
            component: <DadosCadastrais />,
            info: <Typography variant="body2">Informações básicas do agrotóxico.</Typography>,
        },
        {
            label: "Relacionamentos",
            component: <Relacionamentos />,
            info: <Typography variant="body2">Defina os relacionamentos do agrotóxico.</Typography>,
        },
    ];

    return (
        <Box sx={{ px: 4 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            sx={{ alignItems: "flex-start" }}
                            optional={
                                index < activeStep ? (
                                    <Box
                                        sx={{
                                            pl: 4,
                                            top: 8,
                                            left: -20,
                                            position: "relative",
                                            borderLeft: "1px solid #bdbdbd",
                                        }}
                                    >
                                        {step.info}
                                    </Box>
                                ) : null
                            }
                        >
                            <Typography
                                marginBottom={2}
                                color={activeStep === index ? "#000000" : "rgba(0, 0, 0, 0.6)"}
                                variant="subtitle1"
                            >
                                {step.label}
                            </Typography>
                        </StepLabel>
                        <StepContent>{step.component}</StepContent>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
}

interface ISteps {
    label: string;
    component: React.ReactNode;
    info: React.ReactNode;
}